/**
 * Durable local source-cache adapter backed by SafeStorage / localStorage.
 */

import { storageService } from '../storageService';
import type { SourceCacheAdapter, SourceCacheEntry } from './types';

const LOCAL_PREFIX = 'zunelo_source_cache_';

export function localStorageKeyFor(cacheKey: string): string {
  return `${LOCAL_PREFIX}${cacheKey}`;
}

export function createLocalAdapter(): SourceCacheAdapter {
  return {
    get<T>(key: string): SourceCacheEntry<T> | null {
      return storageService.getItem<SourceCacheEntry<T> | null>(localStorageKeyFor(key), null);
    },
    set<T>(key: string, entry: SourceCacheEntry<T>): void {
      storageService.setItem(localStorageKeyFor(key), entry);
    },
    delete(key: string): void {
      storageService.removeItem(localStorageKeyFor(key));
    },
    clear(): void {
      // SafeStorage has no prefix scan; callers invalidate per-key.
    },
  };
}
